import Button from '@/components/primitives/Button.jsx';

/** The end of setup: what Pieve learned, and the one action that opens the first conversation. */
const OnboardingReadyCard = ({ name, isLaunching, onLaunch }) => {
  return (
    <section className="onboarding-ready" aria-labelledby="onboarding-ready-title">
      <h2 className="onboarding-ready__title" id="onboarding-ready-title">
        Thanks, {name}.
      </h2>
      <p className="onboarding-ready__text">Pieve saves what you told it and opens your first conversation, with a short checklist made for your role: connect an app, try a task, and set up one automation.</p>
      <div className="onboarding-ready__actions">
        <Button variant="primary" size="lg" loading={isLaunching} onClick={onLaunch}>
          Start with Pieve
        </Button>
      </div>
    </section>
  );
};

export default OnboardingReadyCard;
